// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AHqc","select":"styles_select__1zecg"};